import React from "react"
import { ChatContentDisplayType } from "../../../../../../../../../../components/templates/chat"
import { Survey } from "../../../../../../../../../../components/templates/chat/components/types/survey"
import { IBaseEditorProps } from "../../abstract/base-editor"
import { container } from "../container"

const Component = (props: IBaseEditorProps) => {
  return (
    <Survey
      displayType={ChatContentDisplayType.Editor}
      surveyId={props.content.survey!.id}
    />
  )
}

export const SurveyEditor = container(Component)
